// Static content for Svara Chakra marketing site.

export const IMAGES = {
  hero: "/images/home-hero.png",
  personal: "https://images.pexels.com/photos/36393357/pexels-photo-36393357.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  retreats: "https://images.pexels.com/photos/28843839/pexels-photo-28843839.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  learning: "https://images.unsplash.com/photo-1425913397330-cf8af2ff40a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA2MjJ8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwZm9yZXN0JTIwc3VubGlnaHR8ZW58MHx8fHwxNzg0MTc4NTUxfDA&ixlib=rb-4.1.0&q=85",
  corporate: "https://images.unsplash.com/photo-1440581572325-0bea30075d9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA2MjJ8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwZm9yZXN0JTIwc3VubGlnaHR8ZW58MHx8fHwxNzg0MTc4NTUxfDA&ixlib=rb-4.1.0&q=85",
  texture: "https://images.pexels.com/photos/36312183/pexels-photo-36312183.jpeg",
};

export const LOGO = "/assets/svara-chakra-logo-new.png";

export const NAV_LINKS = [
  { label: "Home", to: "/", type: "route" },
  { label: "About", to: "/about", type: "route" },
  { label: "Philosophy", to: "philosophy", type: "anchor" },
  { label: "Services", to: "services", type: "anchor" },
  { label: "Retreats", to: "retreats", type: "anchor" },
  { label: "Corporate", to: "corporate", type: "anchor" },
  { label: "Learning", to: "learning", type: "anchor" },
  { label: "Numerology", to: "numerology", type: "anchor" },
  { label: "Journal", to: "journal", type: "anchor" },
  { label: "Contact", to: "/contact", type: "route" },
];

export const SERVICES = [
  {
    id: "personal",
    anchor: "personal",
    index: "01",
    title: "Personal Wellness",
    tagline: "For the individual seeking stillness",
    description:
      "Bespoke one-to-one journeys weaving sound therapy, breath and energy work into a rhythm that returns you to yourself.",
    image: "/images/personal-wellness.png",
  },
  {
    id: "corporate",
    anchor: "corporate",
    index: "02",
    title: "Corporate Wellness",
    tagline: "For teams that lead with presence",
    description:
      "Restorative programs that bring calm, clarity and creative resonance into the modern workplace — measured, considered, humane.",
    image: "/images/corporate-wellness.jpg",
  },
  {
    id: "community",
    anchor: "community",
    index: "03",
    title: "Community Wellness",
    tagline: "For circles that heal together",
    description:
      "Warm, intergenerational gatherings — where music, mindfulness and shared presence weave communities into deeper harmony.",
    image: "/images/community-wellness.png",
  },
  {
    id: "retreats",
    anchor: "retreats",
    index: "04",
    title: "Svara Chakra Wellness Retreat",
    tagline: "For those ready to disappear inward",
    description:
      "Intimate residencies in landscapes of water, forest and light — days shaped by silence, sound baths and conscious nourishment.",
    image: "/images/svara-chakra-wellness-retreat.png",
  },
  {
    id: "learning",
    anchor: "learning",
    index: "05",
    title: "Svara Chakra Learning",
    tagline: "For the student of the self",
    description:
      "Immersive courses and mentorships in music therapy, mindfulness and energy healing — ancient wisdom, taught with modern rigour.",
    image: "/images/svara-chakra-learning.jpg",
  },
];

export const MANIFESTO = [
  {
    number: "01",
    title: "Healing begins within.",
    body: "We believe everyone has the ability to find balance and wellbeing. Through music, holistic healing, and mindful guidance, we’re here to support that journey.",
  },
  {
    number: "02",
    title: "Music transforms from within.",
    body: "As the heart of our work, Music Therapy uses the power of rhythm, melody, and evidence-based practice to support emotional, cognitive, and physical wellbeing.",
  },
  {
    number: "03",
    title: "Ancient wisdom enriches modern life.",
    body: "Reiki, Crystal Healing, Numerology, mindfulness, and holistic education complement contemporary approaches, helping people cultivate balance, clarity, and meaningful change.",
  },
];

export const WHY = [
  {
    title: "A curated ecosystem",
    body: "Music therapy, energy healing, mindfulness and conscious living — thoughtfully woven into one coherent practice.",
  },
  {
    title: "Guided by practitioners",
    body: "Every journey is held by experienced facilitators who lead with warmth, discretion and deep listening.",
  },
  {
    title: "Designed for real life",
    body: "Programs that fold gracefully into busy lives, honouring both your ambition and your need for stillness.",
  },
  {
    title: "A sanctuary, not a service",
    body: "No noise, no funnels, no pressure — only a calm, considered space to reconnect with yourself.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "I arrived exhausted and left rearranged. The sound sessions reached somewhere talking never had. Svara Chakra feels less like a service and more like a sanctuary.",
    name: "Anaïs R.",
    role: "Personal Wellness",
  },
  {
    quote:
      "We brought Svara Chakra into our studio for a quarter. The change in our team's presence and creativity was quietly profound — everyone softened.",
    name: "Marcus L.",
    role: "Corporate Wellness",
  },
  {
    quote:
      "Three days in the forest with sound, silence and extraordinary care. I have been to many retreats. None held me like this one.",
    name: "Priya N.",
    role: "Retreats",
  },
];

export const JOURNAL = [
  {
    tag: "Sound",
    title: "On the frequency of rest",
    excerpt: "How certain tones invite the nervous system to exhale, and why we build our sessions around them.",
    image: IMAGES.texture,
  },
  {
    tag: "Ritual",
    title: "Morning practices for a quieter mind",
    excerpt: "Small, repeatable rituals that reshape a day — drawn from our practitioners' own routines.",
    image: IMAGES.learning,
  },
  {
    tag: "Living",
    title: "Conscious living, gently defined",
    excerpt: "What it means to live consciously without turning wellbeing into another performance.",
    image: IMAGES.personal,
  },
];

export const CONTACT = {
  email: "love@svarachakra.org",
  phone: "+91 89103 98769",
  location: "By appointment · Worldwide",
  hours: "Mon – Sat · 9am to 7pm IST",
};
